import loginRoutes from '@/__mocks__/modules/login/loginRoutes.ts'
import userRoutes from '@/__mocks__/modules/users/userRoutes.ts'
import recoveryRoutes from '@/__mocks__/modules/recovery/recoveryRoutes.ts'
import loggedUserRoutes from '@/__mocks__/modules/loggedUser/loggedUserRoutes.ts'
import rolesRoutes from '@/__mocks__/modules/roles/rolesRoutes.ts'
import branchOfficesRoutes from '@/__mocks__/modules/branchOffices/branchOfficesRoutes.ts'
import setPasswordRoutes from '@/__mocks__/modules/setPassword/setPasswordRoutes.ts'
import clientRoutes from '@/__mocks__/modules/clients/clientRoutes.ts'
import articlesRoutes from '@/__mocks__/modules/articles/articlesRoutes.ts'
import jumioRoutes from '@/__mocks__/modules/jumio/jumioRoutes.ts'
import uninstallAppRoutes from '@/__mocks__/modules/uninstallApp/uninstallAppRoutes.ts'
import brandsRoutes from '@/__mocks__/modules/brands/brandsRoutes.ts'
import alliesRoutes from '@/__mocks__/modules/allies/allyRoutes.ts'
import requestsRoutes from '@/__mocks__/modules/requests/requestsRoutes.ts'
import importRoutes from '@/__mocks__/modules/import/importRoutes.ts'
import pendingRechargeRoutes from '@/__mocks__/modules/pendingRecharge/pendingRechargeRoutes.ts'
import collectionsRoutes from '@/__mocks__/modules/collections/collectionsRoutes.ts'
import categoryRoutes from '@/__mocks__/modules/categories/categoryRoutes.ts'
import reportRoutes from '@/__mocks__/modules/reports/reportRoutes.ts'
import walletRoutes from '@/__mocks__/modules/wallet/walletRoutes.ts'
import trademarkRoutes from '@/__mocks__/modules/trademarks/trademarkRoutes.ts'
import statesRoutes from '@/__mocks__/modules/states/statesRoutes.ts'
import supplierRoutes from '@/__mocks__/modules/suppliers/supplierRoutes.ts'
import servicesRoutes from '@/__mocks__/modules/services/servicesRoutes.ts'
import clientLevelRoutes from '@/__mocks__/modules/clientLevels/clientLevelRoutes.ts'
import { levelsRoutes } from '@/__mocks__/modules/clientLevels/levelsRoutes.ts'
import serviceCentersRoutes from '@/__mocks__/modules/serviceCenters/serviceCentersRoutes.ts'
import rentabilityConfigurationRoutes from '@/__mocks__/modules/reports/rentabilityConfigurationRoutes.ts'
import claimsRoutes from '@/__mocks__/modules/claims/claimsRoutes.ts'
import calculatorRoutes from '@/__mocks__/modules/calculator/calculatorRoutes.ts'
import bankRoutes from '@/__mocks__/modules/banks/bankRoutes.ts'
import salesRoutes from '@/__mocks__/modules/sales/salesRoutes.ts'
import publicityRoutes from '@/__mocks__/modules/publicity/publicityRoutes.ts'
import marketplaceRoutes from '@/__mocks__/modules/marketplace/marketplaceRoutes.ts'
import campaignsRoutes from '@/__mocks__/modules/campaigns/campaignsRoutes.ts'
import drawsRoutes from '@/__mocks__/modules/draws/drawsRoutes.ts'
import campaignPrizesRoutes from '@/__mocks__/modules/campaignPrizes/campaignPrizesRoutes.ts'
import drawPrizesRoutes from '@/__mocks__/modules/drawPrizes/drawPrizesRoutes.ts'
import promotionsRoutes from '@/__mocks__/modules/promotions/promotionsRoutes.ts'

export const routes = [
  ...loginRoutes,
  ...recoveryRoutes,
  ...loggedUserRoutes,
  ...userRoutes,
  ...rolesRoutes,
  ...branchOfficesRoutes,
  ...setPasswordRoutes,
  ...clientRoutes,
  ...articlesRoutes,
  ...jumioRoutes,
  ...uninstallAppRoutes,
  ...brandsRoutes,
  ...alliesRoutes,
  ...requestsRoutes,
  ...importRoutes,
  ...pendingRechargeRoutes,
  ...collectionsRoutes,
  ...categoryRoutes,
  ...reportRoutes,
  ...walletRoutes,
  ...statesRoutes,
  ...trademarkRoutes,
  ...supplierRoutes,
  ...servicesRoutes,
  ...clientLevelRoutes,
  ...levelsRoutes,
  ...serviceCentersRoutes,
  ...rentabilityConfigurationRoutes,
  ...claimsRoutes,
  ...calculatorRoutes,
  ...bankRoutes,
  ...salesRoutes,
  ...publicityRoutes,
  ...marketplaceRoutes,
  ...campaignsRoutes,
  ...drawsRoutes,
  ...campaignPrizesRoutes,
  ...drawPrizesRoutes,
  ...promotionsRoutes
]
